<template>
  <div v-if="NOTARIA" class="solicitud-page">
    <ClientOnly>
      <SolicitudCargando v-if="!textosListos || !configCargada" :texto="t('Cargando formulario…')" />
      <SolicitudWizard v-else-if="activa" />
      <div v-else class="solicitud-page__aviso">
        <h1>{{ t('Encargo online no disponible') }}</h1>
        <p>
          {{ t('En este momento la notaría no admite encargos online.') }}
          <template v-if="NOTARIA.Contacto?.Telefono || NOTARIA.Contacto?.Email">
            {{ t('Puede contactar en') }}
            <a v-if="NOTARIA.Contacto?.Telefono" :href="'tel:' + NOTARIA.Contacto.Telefono">{{ NOTARIA.Contacto.Telefono }}</a>
            <template v-if="NOTARIA.Contacto?.Telefono && NOTARIA.Contacto?.Email"> {{ t('o') }} </template>
            <a v-if="NOTARIA.Contacto?.Email" :href="'mailto:' + NOTARIA.Contacto.Email">{{ NOTARIA.Contacto.Email }}</a>.
          </template>
        </p>
      </div>
      <template #fallback>
        <SolicitudCargando :texto="t('Cargando formulario…')" />
      </template>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { t, textosListos, cargarTextosSolicitud } from '../composables/solicitudTextos'
import { computed, toRaw } from 'vue'
import { useStore } from '../store/index'
import { useSolicitudWeb } from '../composables/useSolicitudWeb'
const store = useStore()
const { NOTARIA } = storeToRefs(store)
// La configuración (común a todos los idiomas) llega de la API junto con el catálogo
const { config, estadoCatalogo, cargarCatalogo } = useSolicitudWeb()
// Una vez cargada no se vuelve a la pantalla de carga (p. ej. al recargar el catálogo por cambio de idioma)
let yaCargada = false
const configCargada = computed(() => {
  if (estadoCatalogo.value === 'listo' || estadoCatalogo.value === 'respaldo') yaCargada = true
  return yaCargada
})
const activa = computed(() => !!config.value.Activa)
if (import.meta.client) cargarCatalogo()
if (import.meta.client) cargarTextosSolicitud()
const PageName = 'encargo-online'
if (store.NOTARIA) useMetaTags(toRaw(store.NOTARIA), PageName)
// El formulario contiene datos personales: que no lo indexen los buscadores
useHead({ meta: [{ name: 'robots', content: 'noindex, nofollow' }] })
</script>

<style lang="scss">
.solicitud-page {
  margin-top: 82px;
  &__aviso {
    max-width: 640px; margin: 0 auto; padding: 80px 16px; text-align: center; color: #5f6b76;
    h1 { color: #1d2329; font-size: 1.6rem; margin-bottom: 12px; }
  }
}
</style>
